export default "__VITE_PUBLIC_ASSET__e4f836d2__"